module.exports = __webpack_public_path__ + "img/DockerHub.36dfa8f.svg";